import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../../../settings/settings.service';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';


@Component({
    selector: 'app-cuenta-archivos',
    templateUrl: './cuenta-archivos.component.html',
    styleUrls: ['./cuenta-archivos.component.less'],
    standalone: true,
    imports: [
      MatDialogModule,
      CommonModule,
      MatTooltipModule,
      MatIconModule

    ]
})
export class CuentaArchivosComponent implements OnInit {
  showSpinner = false
  id_cuenta:any
  parent_index:any
  has_file=false
  archivos:any[]=[]
  parent:any
  valFormCarpeta: FormGroup;
  loading: boolean = false;
  constructor(
    public settings:SettingsService,
    public snackBar: MatSnackBar,
    fb: FormBuilder,
  ) { 
    this.valFormCarpeta = fb.group({
      'file_upload':[null],
    })
  }

  ngOnInit() {
    this.cargar_carpeta()
  }

  @ViewChild('fileChooser') fileChooser!: ElementRef<HTMLInputElement>;
  open_chooser()
  {
    this.fileChooser.nativeElement.click();
  }

   upload_file=async($e:any)=>{

    this.loading = true;

    let formData: FormData = new FormData();

    this.showSpinner = true

    let file_input = $e.target.files;

    for(let i=0;i<file_input.length;i++){
      let name = file_input[i].name
      formData.append('file_'+i, file_input[i], name);
  }

    let resultado:any = (await this.settings.get_query(2, `/DocumentGiroTercero/${this.id_cuenta}/`, formData))      
    let body_data=resultado._body;


    if(!body_data['error']){
      // 
      this.cargar_carpeta()
      if(this.parent!=undefined){
        this.parent.checkArchivos()
      }
      this.snackBar.open(`¡Documento Agregado con exito! comentario IA: ${body_data.analisis_gpt
            }`, "Aceptar", {
        duration: 1500,
        panelClass: ['JP-snackbar']
      });

      this.loading = false;
    }
    else{
      this.loading = false;
    }
  }

  cargar_carpeta=async()=>{
    this.loading = true;
    let resultado:any = (await this.settings.get_query(1, `/DocumentGiroTercero/${this.id_cuenta}/`))      
    let body_data=resultado._body;
    this.archivos=[]

    if(!body_data['error']){
      // 
      this.showSpinner = false
      
      let files=body_data["files"]
      this.archivos=files.map((file:any)=>{
        let ruta=file.document;
        let url=''+SettingsService.API_ENDPOINT + 'media/'+"giroTercero/"+ruta
        let obj = {'file': ruta, 'ruta':url, "visto":file.visto, "id":file.id, "account_id":file.account_id, "date_created":file.date_created, "descripcion_asistente": file.descripcion_asistente, "checkeo_asistente": file.checkeo_asistente}
        return obj
        }
      ).filter((file:any)=>file!==undefined)
      this.has_file=this.archivos.length>0 ? true : false
      if(this.parent!=undefined){
        let banco=this.parent.data[this.parent_index].bancos.find((x:any)=>x.id==this.id_cuenta)
        if(this.has_file){
          banco.has_file=true
          
          let index=this.parent.data[this.parent_index].bancos.indexOf(banco)
          this.parent.data[this.parent_index].bancos[index]=banco
        }

      }

      this.loading = false;

    }
    else{
      this.loading = false;
    }
  }

  marcar_carpeta=async(id_file:any)=>{
    let value={visto: true}
    let resultado:any = (await this.settings.get_query(3, `/DocumentGiroTercero/${id_file}/`,value))      
    let body_data=resultado._body;
    if(!body_data['error']){
      // 
      
      this.cargar_carpeta()
      if(this.parent!=undefined){
        this.parent.checkArchivos()
      }
    }
    else{

    }
  }

  async descargarArchivo(file: any) {
    if (file.visto) {
      window.open(file.ruta, '_blank');
      return;
    }

    try {
      await this.marcar_carpeta(file.id);
    } catch (err) {
      console.error('Error marcando archivo como visto', err);
    }

    window.open(file.ruta, '_blank');
  }
  
}
